// Round 4c: how busy the network is right now, so display-only reads (shell badges, help catalogue) wait for the page's own reads
// instead of racing them for the browser's 6 connections. Counts fetches through the api layer; no behaviour of its own.
let busy = 0, lastStart = 0;
export function trackFetch(promise) { busy++; lastStart = Date.now(); const done = () => { busy--; }; promise.then(done, done); return promise; }
export const netQuietFor = (ms, now = Date.now()) => busy === 0 && now - lastStart >= ms;
